(function () {
  const form = document.getElementById('ContactFooter');
  if (!form) return;

  form.addEventListener('submit', function () {
    const button = form.querySelector('#Subscribe');
    if (!button) return;

    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    button.disabled = true;
  });
})();
